export const PRESET_ZOOM_LEVELS = [400, 300, 200, 180, 160, 140, 120, 100, 80, 60, 40, 20];
export const ZOOM_MAX = PRESET_ZOOM_LEVELS[0] / 100;
export const ZOOM_MIN = PRESET_ZOOM_LEVELS[PRESET_ZOOM_LEVELS.length - 1] / 100;
export const ZOOM_CHANGE_STEP = 0.2;
export const ZOOM_SCROLL_STEP = 0.001;
export const ZOOM_CONTROL_TEST_ID = 'zoom-control';
export const ZOOM_CONTROL_INPUT_TEST_ID = 'zoom-control-input';
export const ZOOM_CONTROL_INITIAL_OFFSET = 128;
export const ZOOM_CONTROL_OFFSET_WITH_SIDE_PANEL = 16;
export const DEFAULT_CENTER_RATIO = 0.5;
export const PADDING_OFFSET = 48; // page container padding offsets, 24 x 24 pixelsize for long portrait layout (pixels)
export const LONG_PORTRAIT_BREAKPOINT = 1350;
